<template>
  <div id="admin-container">
    <Title title="Admin"></Title>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{
      snackbarText
    }}</v-snackbar>
    <v-container>
      <v-row>
        <template v-if="$store.state.role == 'ao'">
          <h2 class="pl-3 pt-3">Report</h2>
          <v-col lg="12" md="12" sm="12">
            <v-form ref="reportForm">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    label="Select a date range for report"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="emptyRule"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="reportDates" no-title scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-form>
            <v-btn tile color="primary" @click="onGenerateReport()" class="mt-3"
              >Generate Report</v-btn
            ></v-col
          >
        </template>
        <v-col lg="12" md="12" sm="12">
          <UserTable
            :headers="userHeaders"
            :items="users"
            :title="'user.user'"
            :modalText="'User'"
            :apiRoute="'users'"
            :isLoading="isUsersLoading"
            @optionAdded="onOptionAdded"
          />
        </v-col>
        <v-col lg="12" md="12" sm="12">
          <MasterTable
            :headers="countryHeaders"
            :items="countries"
            :title="'country.country'"
            :modalText="'Country'"
            :apiRoute="'countries'"
            @optionAdded="onOptionAdded"
            v-if="role == 'master'"
          />
        </v-col>
        <v-col lg="12" md="12" sm="12">
          <MasterTable
            :headers="nationalityHeaders"
            :items="nationalities"
            :title="'nationality.nationality'"
            :modalText="'Nationality'"
            :apiRoute="'nationalities'"
            @optionAdded="onOptionAdded"
            v-if="role == 'master'"
          />
        </v-col>
        <v-col lg="12" md="12" sm="12">
          <MasterTable
            :headers="ethnicityHeaders"
            :items="ethnicities"
            :title="'ethnicity.ethnicity'"
            :modalText="'Ethnicity'"
            :apiRoute="'ethnicities'"
            @optionAdded="onOptionAdded"
            v-if="role == 'master'"
          />
        </v-col>
        <v-col lg="12" md="12" sm="12">
          <MasterTable
            :headers="unitTypeHeaders"
            :items="unitTypes"
            :title="'type.type'"
            :modalText="'Type'"
            :apiRoute="'unitTypes'"
            @optionAdded="onOptionAdded"
            v-if="role == 'master'"
          />
        </v-col>
        <v-col lg="12" md="12" sm="12">
          <MasterTable
            :headers="unitLevelHeaders"
            :items="unitLevels"
            :title="'level.level'"
            :modalText="'Level'"
            :apiRoute="'unitLevels'"
            @optionAdded="onOptionAdded"
            v-if="role == 'master'"
          />
        </v-col>
        <v-col lg="12" md="12" sm="12">
          <MasterTable
            :headers="unitStatusHeaders"
            :items="unitStatuses"
            :title="'status.status'"
            :modalText="'Status'"
            :apiRoute="'unitStatuses'"
            @optionAdded="onOptionAdded"
            v-if="role == 'master'"
          />
        </v-col>
        <v-col lg="12" md="12" sm="12">
          <MasterTable
            :headers="learnerStatusHeaders"
            :items="learnerStatuses"
            :title="'Learner status'"
            :modalText="'Status'"
            :apiRoute="'learnerStatuses'"
            @optionAdded="onOptionAdded"
            v-if="role == 'master'"
          />
        </v-col>
        <v-col lg="12" md="12" sm="12">
          <MasterTable
            :headers="languageHeaders"
            :items="languages"
            :title="'language.language'"
            :modalText="'Language'"
            :apiRoute="'languages'"
            @optionAdded="onOptionAdded"
            v-if="role == 'master'"
          />
        </v-col>
        <v-col lg="12" md="12" sm="12">
          <MasterTable
            :headers="centreStatusHeaders"
            :items="centreStatuses"
            :title="'centreStatus.centreStatus'"
            :btnText="'centre status'"
            :modalText="'Status'"
            :apiRoute="'centreStatuses'"
            @optionAdded="onOptionAdded"
            v-if="role == 'master'"
          />
        </v-col>
        <v-col lg="12" md="12" sm="12">
          <MasterTable
            :headers="gradingCriterionHeaders"
            :items="gradingCriterions"
            :title="'gradingCriterion.gradingCriterion'"
            :modalText="'Criterion'"
            :apiRoute="'gradingCriterions'"
            @optionAdded="onOptionAdded"
            v-if="role == 'master'"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import UserTable from "../components/UserTable";
import MasterTable from "../components/MasterTable";
import Title from "../components/Title";

export default {
  mounted: function () {
    this.getUsers();

    this.role = this.$store.state.role;

    if (this.role == "master") {
      this.getCountries();
      this.getNationalities();
      this.getEthnicities();
      this.getUnitTypes();
      this.getUnitLevels();
      this.getUnitStatuses();
      this.getLearnerStatuses();
      this.getLanguages();
      this.getCentreStatuses();
      this.getGradingCriterions();
    }
  },
  components: {
    UserTable,
    MasterTable,
    Title,
  },
  data: function () {
    return {
      role: null,
      dialog: false,
      snackbar: false,
      snackbarText: "",
      users: [],
      countries: [],
      nationalities: [],
      ethnicities: [],
      unitTypes: [],
      unitLevels: [],
      unitStatuses: [],
      learnerStatuses: [],
      languages: [],
      centreStatuses: [],
      gradingCriterions: [],
      isUsersLoading: true,
      reportDates: [],
      menu: false,
      emptyRule: [
        () =>
          this.reportDates.length >= 2 ||
          "Date range is required to generate report",
      ],
    };
  },
  watch: {
    isUsersLoading: function (newValue) {
      this.isUsersLoading = newValue;
    },
  },
  computed: {
    dateRangeText() {
      return this.reportDates.join(" - ");
    },
    userHeaders: function () {
      if (
        this.$store.state.role == "master" ||
        this.$store.state.role == "ao"
      ) {
        return [
          {
            text: this.$t("user.username"),
            align: "start",
            sortable: true,
            value: "username",
          },
          { text: "Email address", value: "email" },
          { text: this.$t("user.role"), value: "role" },
          {
            text: this.$t("table.actions"),
            value: "actions",
            align: "end",
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: this.$t("user.username"),
            align: "start",
            sortable: true,
            value: "username",
          },
          { text: "Email address", value: "email" },
          { text: this.$t("user.role"), value: "role" },
        ];
      }
    },
    countryHeaders: function () {
      return [
        {
          text: this.$t("country.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: this.$t("country.code"), value: "code" },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    nationalityHeaders: function () {
      return [
        {
          text: this.$t("nationality.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    ethnicityHeaders: function () {
      return [
        {
          text: this.$t("ethnicity.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    unitTypeHeaders: function () {
      return [
        {
          text: this.$t("type.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    unitLevelHeaders: function () {
      return [
        {
          text: this.$t("level.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    unitStatusHeaders: function () {
      return [
        {
          text: this.$t("status.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    learnerStatusHeaders: function () {
      return [
        {
          text: this.$t("status.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    languageHeaders: function () {
      return [
        {
          text: this.$t("language.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    centreStatusHeaders: function () {
      return [
        {
          text: this.$t("centreStatus.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    gradingCriterionHeaders: function () {
      return [
        {
          text: this.$t("gradingCriterion.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    onGenerateReport: async function () {
      try {
        if (!this.$refs.reportForm.validate()) return;

        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/reports?startDate=${this.reportDates[0]}&endDate=${this.reportDates[1]}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
          }
        );
        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "report.csv"; // the filename you want
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.log(err);
      }
    },
    getUsers: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/users`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.users = data.users;
          this.isUsersLoading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getCountries: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/countries`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.countries = data.countries;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getNationalities: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/nationalities`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.nationalities = data.nationalities;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getEthnicities: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/ethnicities`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.ethnicities = data.ethnicities;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getUnitTypes: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/unitTypes`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.unitTypes = data.unitTypes;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getUnitLevels: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/unitLevels`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.unitLevels = data.unitLevels;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getUnitStatuses: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/unitStatuses`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.unitStatuses = data.unitStatuses;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getLearnerStatuses: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/learnerStatuses`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.learnerStatuses = data.learnerStatuses;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getLanguages: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/languages`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.languages = data.languages;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getCentreStatuses: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/centreStatuses`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.centreStatuses = data.centreStatuses;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getGradingCriterions: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/gradingCriterions`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.gradingCriterions = data.gradingCriterions;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onOptionAdded: function (data) {
      this.getUsers();

      switch (data.title) {
        case "countries":
          this.getCountries();
          break;
        case "nationalities":
          this.getNationalities();
          break;
        case "ethnicities":
          this.getEthnicities();
          break;
        case "unitTypes":
          this.getUnitTypes();
          break;
        case "unitLevels":
          this.getUnitLevels();
          break;
        case "unitStatuses":
          this.getUnitStatuses();
          break;
        case "learnerStatuses":
          this.getLearnerStatuses();
          break;
        case "languages":
          this.getLanguages();
          break;
        case "centreStatuses":
          this.getCentreStatuses();
          break;
        case "gradingCriterions":
          this.getGradingCriterions();
          break;
        default:
          break;
      }

      this.snackbarText = data.message;
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
#admin-container {
  min-height: 100vh;
}
</style>